import { useEffect } from "react";

/**
 * Non-RFID prototype: an order that ended without the door ever opening (autolock, or a late FINISHED
 * echo landing in an empty slot) has nothing to hand off — go straight home.
 */
export const NonRfidResetStep = ({ resetOrder }: { resetOrder: () => void }) => {
	useEffect(() => {
		resetOrder();
	}, [resetOrder]);
	return null;
};
